import { defineFcm } from '../shared/factory';

export const FCM_PLATFORM_FRAUD_EMAIL_DOMAINS = defineFcm('platform_fraud_email_domains')
	.asString()
	.withDefault(undefined)
	.toConfig();
